/**
 * The channel limits the signed-in user's plan includes, exactly as rails sends
 * them on GET /api/v2/session (`plan_limits`, from rails' `User#plan_limits`).
 * Rails is the one home for these numbers and enforces them on every channel
 * save, so the dashboard only reads them:
 *   - `photo_filters`: the most live photo filters a channel may hold, or null
 *     for no limit (Lite: 1);
 *   - `gallery_banner`: whether the plan includes a gallery logo (Lite: false).
 *
 * A session without `plan_limits` (not loaded yet) limits nothing here: the save
 * goes out and rails' answer decides, arriving as a 422 whose message the
 * channel form already shows.
 */
export const NO_PLAN_LIMITS = Object.freeze({ photo_filters: null, gallery_banner: true });

export const planLimitsForUser = (user) => {
  const limits = user && user.plan_limits;
  if (!limits || typeof limits !== "object") return NO_PLAN_LIMITS;

  return {
    photo_filters: Number.isInteger(limits.photo_filters) ? limits.photo_filters : null,
    gallery_banner: limits.gallery_banner !== false,
  };
};
